<div *adaptLoading="!initialised">
    <dx-chart class="display-survey-history-chart"
              [dataSource]="chartData"
              [customizePoint]="customiseChartPoint"
              [adjustOnZoom]="false"
              [barGroupWidth]="hasMultiResponseGroups ? 80 : undefined"
              (onPointClick)="onPointClicked($event)"
              (onDone)="updateChartDimensionAndSubscribeSizeChange($event)">
        <dxo-chart-tooltip [enabled]="true"
                           [customizeTooltip]="customiseChartTooltip"></dxo-chart-tooltip>
        <dxo-chart-argument-axis type="discrete">
            <dxo-chart-label [customizeText]="customizeDate"></dxo-chart-label>
        </dxo-chart-argument-axis>
        <dxi-chart-value-axis name="score"
                              position="left"
                              [valueMarginsEnabled]="false"
                              [showZero]="true"
                              [visualRange]="[0, 100]"
                              visualRangeUpdateMode="keep">
            <dxo-chart-grid [visible]="true"></dxo-chart-grid>
            <dxo-chart-title text="Average score, %"></dxo-chart-title>
        </dxi-chart-value-axis>
        <dxi-chart-value-axis name="participation"
                              [valueMarginsEnabled]="false"
                              [showZero]="true"
                              [visualRange]="[0, 100]"
                              visualRangeUpdateMode="keep"
                              position="right">
            <dxo-chart-grid [visible]="true"></dxo-chart-grid>
            <dxo-chart-title text="Participation rate, %"></dxo-chart-title>
        </dxi-chart-value-axis>
        <dxi-chart-series valueField="score"
                          axis="score"
                          tagField="scoreTag"
                          type="bar"
                          [showInLegend]="false"
                          name="Average score">
            <dxo-chart-point [visible]="true"></dxo-chart-point>
        </dxi-chart-series>
        @if (hasMultiResponseGroups) {
            <dxi-chart-series valueField="leaderScore"
                              axis="score"
                              tagField="leaderTag"
                              type="bar"
                              [showInLegend]="false"
                              name="Average Leader Score">
                <dxo-chart-point [visible]="true"></dxo-chart-point>
            </dxi-chart-series>
            <dxi-chart-series valueField="nonLeaderScore"
                              axis="score"
                              tagField="nonLeaderTag"
                              type="bar"
                              [showInLegend]="false"
                              name="Average Employee Score">
                <dxo-chart-point [visible]="true"></dxo-chart-point>
            </dxi-chart-series>
        }
        @for (series of legendSeries; track series) {
            <dxi-chart-series [name]="series.name"
                              [color]="series.color">
                <dxo-chart-label [visible]="false"></dxo-chart-label>
            </dxi-chart-series>
        }
        <dxi-chart-series valueField="participation"
                          axis="participation"
                          tagField="participationTag"
                          argumentField="endTime"
                          type="spline"
                          color="#60a69f"
                          [width]="0.5"
                          name="Participation rate">
            <dxo-chart-label [visible]="false"></dxo-chart-label>
            <dxo-chart-point [visible]="true"
                             color="#5f8b95"
                             symbol="cross"
                             [size]="8"></dxo-chart-point>
            <dxo-chart-hover-style [width]="1"></dxo-chart-hover-style>
        </dxi-chart-series>
        <dxo-chart-common-series-settings valueField="zero"
                                          type="scatter"
                                          argumentField="endTime">
            <dxo-chart-point [visible]="false"></dxo-chart-point>
            <dxo-chart-label [visible]="hasMultiResponseGroups"
                             [rotationAngle]="-90"
                             position="inside"
                             backgroundColor="#00000000"
                             [verticalOffset]="2000"
                             [horizontalOffset]="-2"
                             [customizeText]="customiseChartLabel">
                <dxo-chart-font [size]="16"></dxo-chart-font>
            </dxo-chart-label>
        </dxo-chart-common-series-settings>
        <dxo-chart-legend verticalAlignment="bottom"
                          [columnCount]="4"
                          itemTextPosition="right"
                          horizontalAlignment="center"></dxo-chart-legend>
    </dx-chart>
</div>
